import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { isCodelessEventsApp } from '../modules/codeless-events/utils/isCodelessEventsApp';

export const queryClient = new QueryClient();

export const QueryProvider = ({ children }) => (
    <QueryClientProvider client={queryClient}>
        {children}
        {!isCodelessEventsApp() && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
);
